// Keep in sync with `RESTRICTED_MODEL_NAMES` in packages/github_models/app/models/github_models/model.rb
// TODO: remove this TypeScript list of restricted model names in favor of the Ruby one server-side.
export const allRestrictedModelNames = ['o1', 'o1-mini', 'o1-preview', 'o3-mini', 'o3']

export const userHasAccessToModel = (name: string, restrictedModels: string[]) => {
  if (allRestrictedModelNames.includes(name)) {
    return restrictedModels.includes(name)
  }
  return true
}
